import React from 'react';
import { Container, Typography, Paper, Grid } from '@material-ui/core';
import useStyles from './styles.js'; // Import your styles
import squad from '../../images/image.png';

const Mission = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Paper className={classes.paper} elevation={3}>
      <Typography variant="h4" className={classes.missionTitle}  style={{ color: '#FFA500' }}>
              Our Mission
            </Typography>
        <Grid container spacing={3}>
          {/* Mission Description */}
          
          <Grid item xs={12} md={6}>
            


            <img
              src={squad} // Replace with your group image path
              alt="Our Group"
              className={classes.groupImage}
            />
            {/* Google Maps Link */}
            {/* <Typography variant="body2" className={classes.mapLink}>
              Explore our events on{' '}
              <a
                href="https://www.google.com/maps" // Replace with your Google Maps link
                target="_blank"
                rel="noopener noreferrer"
                className={classes.linkText}
              >
                Google Maps
              </a>
            </Typography> */}
          </Grid>

          {/* Group Image */}
          <Grid item xs={12} md={6}>
           
          <Typography variant="body2" className={classes.missionText}>
            SERV (Service to Engage and Recruit Volunteers) is a program born
              from innovation and commitment. Our mission is to foster
              community engagement by connecting dedicated volunteers with
              passionate event organizers. We believe in the power of
              volunteering to transform lives and build stronger communities.
              Through SERV, we aim to make it easier than ever for individuals
              to find and participate in meaningful volunteer opportunities that
              align with their passions and skills.
            </Typography>
          
           
          </Grid>
          <Typography variant="body3" className={classes.missionText}>
              Founded by Harjot Dehal, Simrat Kaur, Manpreet Kaur, and Jasmine Hanjra,
              SERV represents our dedication to making a positive impact on the world
              by bridging the gap between volunteers and those in need. Together, we're
              committed to empowering individuals to create lasting change in their communities.
          
          
          
            </Typography>
          
{/* <Typography variant="body3" className={classes.missionText}>
              Founded by Harjot Dehal, Shubh Singh and Company, SERV represents our dedication to making a positive impact on the world
              by bridging the gap between volunteers and those in need. Left-most, Harjot,
              middle-left, Shubh, middle-right, Karan, and right-most, Gurvir Dhaliwal,
              together, we're committed to empowering individuals to create lasting change in their communities.
            </Typography> */}



           
        </Grid>
      </Paper>
    </Container>
  );
};

export default Mission;
